import { createAPI } from '@common'

export default {
  // 获取所有域名目录
  getDomaindirs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0epnbjoejst', 'get', config), // siteID: 站点id

  // 获取域名目录(第一层以及子层)
  getDomaindirsByPid: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0epnbjoejst0cz0qje', 'get', config), // siteID: 站点id, parentID: 父节点id

  // 初始化站点目录资源
  getDomaindirsInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0epnbjoejst0joju', 'get', config), // siteID: 站点id

  // 判断域名目录是否被引用
  getDomaindirsIsUsed: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0epnbjoejst0jt0vtfe', 'get', config), // dirID: 目录id
  // 删除目录

  deleteDomaindirs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0epnbjoejst0efmfuf', 'delete', config),

  // 将指定目录作为资源目录
  getDomaindirsResourceSet: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0epnbjoejst0sftpvsdf0tfu', 'get', config),

  // 添加目录
  postDomaindirAdd: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0epnbjoejst0bee', 'post', config), // siteID: 站点, parentDocID: 父节点的docID, dirname: 目录名

  // 切换域名（修改）
  postDomaindirSwitch: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0epnbjoejst0txjudi', 'post', config), // dirID: 目录docID, newUrl: 新的url

  // 域名切换（获取原始域名）
  getDomaindirInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0epnbjoejst0jogp', 'get', config), // dirID: 目录docID, newUrl: 新的url

  // 设置域名百度推送地址
  setPushUrl: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0epnbjoejst0sftpvsdf0tfuQvtiVsm', 'post', config), // dirID: 目录docID, pushUrl: 推送地址最长不能超过255

  // 域名目录查重
  // getDomaindirDuplicate: (config) =>
  //   createAPI('customEncryptApiName-1/0nfejby.tjuf0epnbjoejst0evqmjdbuf', 'get', config) // siteID 站点ID, docID 资源目录ID, parentID 父目录ID, value 目录名称, field 字段(dir_name)
  // 域名url查重
  getDomaindirUrlDuplicate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0epnbjoejst0vsmEvqmjdbuf', 'get', config), // siteID 站点ID, docID 资源目录ID, parentID 父目录ID, value 目录名称, field 字段(dir_name)
  // 域名名称查重
  getDomaindirDuplicate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tjuf0epnbjoejst0ejsEvqmjdbuf', 'get', config) // siteID 站点ID, docID 资源目录ID, parentID 父目录ID, value 目录名称, field 字段(dir_name)    
}
